import { getExeStatusOrdersTable } from "../../../../Requests/adjustment";
import { CommonTableUI } from "../../../TableTemplate/common";
import TableTemplate from "../../../TableTemplate/tableTemplate";

interface IProps {
  taskId: number;
  adjusmentExeTab: string;
}

const OrdersTable = ({ taskId, adjusmentExeTab }: IProps) => {
  return (
    <TableTemplate
      TableUI={({ reports, onAction }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          tableBoxClassName="!max-h-[500px] order-table"
        />
      )}
      getDataTable={getExeStatusOrdersTable}
      initialSearchParameters={{ taskId, adjusmentExeTab }}
      refreshTableTime={10000}
    />
  );
};

export default OrdersTable;
